import React, { Component } from 'react';
import styles from './style.module.scss';

export default class Footer extends Component {
  render() {
    return <div className={styles['footer']}>{this.props.children}</div>;
  }
}
